<template>
  <div class="nav-wrap">
      <div class="header-wrp">
          <Header></Header>
      </div>
      <img-bg
        :poster="bgUrl"
        :opacity='"1"'
        :isRelative="false"
        :height="391"></img-bg>
      <div class="nav-content">
          <content-tank
            title="基础数据管理">
            <div
                slot="content">
                <div class="nav-flex">
                    <div
                        class="nav-flex-item"
                        v-for="item in navList"
                        :key="item.name"
                        @click="toPath(item.path)">
                        <img :src="item.url" alt="" width="48" height="48">
                        <p class="nav-flex-item-text">
                            {{item.name}}
                        </p>
                    </div>
                </div>
            </div>
        </content-tank>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            bgUrl: 'https://image1.guazistatic.com/trans_sdm_bg.png',
            navList: [
                {
                    url: 'https://image1.guazistatic.com/icon-nav1.png',
                    name: '供应商基本信息查看',
                    path: '/read',
                },
                {
                    url: 'https://image1.guazistatic.com/icon-nav2.png',
                    name: '供应商基本信息变更',
                    path: '/read?type=1',
                },
                // {
                //     url: 'https://image1.guazistatic.com/icon-nav3.png',
                //     name: '供应商变更申请查询',
                // },
            ],
        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo.userInfo,
        }),
    },
    methods: {
        toPath(path) {
            this.$router.push(path)
        },
    },
}
</script>

<style lang="scss">
.nav-wrap{
    .header-wrp{
        height: 70px;
        z-index: 2020;
    }
    .nav-content{
        width:80%;
        margin:278px auto;
        padding:40px;
        background-color: #fff;
        .nav-flex{
            display: flex;
            justify-content: flex-start;
            &-item{
                width:140px;
                text-align: center;
                &-text{
                    font-size:12px;
                    font-weight: 400;
                    color: #424C58;
                    line-height: 24px;
                }
            }
        }

    }
}
</style>
